import { FormControl, MenuItem, Select, SelectProps } from '@mui/material';
import React from 'react';

import { LocationMatchType } from 'app/enum';

type LocationMatchTypeCompProps = SelectProps<LocationMatchType> & {
    value: LocationMatchType;
    name: string;
    size?: 'medium' | 'small';
};

export const LocationMatchTypeComp: React.FC<LocationMatchTypeCompProps> = (props) => {
    return (
        <FormControl style={{ minWidth: '5em' }} size={props.size}>
            <Select {...props}>
                <MenuItem value={LocationMatchType.EQUAL}>Equal</MenuItem>
                <MenuItem value={LocationMatchType.LIKE}>Like</MenuItem>
                <MenuItem value={LocationMatchType.REGEX}>RegEx</MenuItem>
                <MenuItem value={LocationMatchType.NOT_LIKE}>NOT Like</MenuItem>
                <MenuItem value={LocationMatchType.NOT_REGEX}>NOT RegEx</MenuItem>
            </Select>
        </FormControl>
    );
};
